import { createSelector } from "reselect"
import { reducerInit } from "../../api/dbselect.js"

const init = reducerInit("servicequestion", "sqorder")

export const serviceQuestionReducer = (state = init, action) => {
	switch (action.type) {
		case "INSERT_SERVICEQUESTION":
			return [...state, action.response[0]]

		case "UPDATE_SERVICEQUESTION": {
			const updatedState = state.map((object) => {
				if (object.servicequestionid === action.id) {
					return { ...object, ...action.json }
				}
				return object
			})
			return [...updatedState]
		}

		case "DELETE_SERVICEQUESTION":
			return state.filter((object) => object.servicequestionid !== action.id)

		default:
			return state
	}
}

export const selectQuestionsByServiceId = createSelector(
	(state, serviceId) => state.serviceQuestionReducer,
	(_, serviceId) => serviceId,
	(questions, serviceId) =>
		questions.filter((question) => {
			return question.serviceid === serviceId
		})
)

export const selectQuestionsWithOnlyIdsByServiceId = createSelector(
	(state, serviceId) => state.serviceQuestionReducer,
	(_, serviceId) => serviceId,
	(questions, serviceId) =>
		questions
			.filter((question) => question.serviceid === serviceId && question.parent === null)
			.map((question) => question.servicequestionid)
)

export const selectQuestionsByParentId = createSelector(
	(state, questionId) => state.serviceQuestionReducer,
	(_, questionId) => questionId,
	(questions, questionId) => questions.filter((question) => question.parent === questionId)
)

export const selectQuestionsByServiceIdAndParentId = createSelector(
	[(state) => state.serviceQuestionReducer, (_, serviceId) => serviceId, (_, __, questionId) => questionId],
	(questions, serviceId, questionId) => {
		if (questionId === null) {
			return questions.filter((question) => question.serviceid === serviceId && question.parent === null)
		} else {
			return questions.filter((question) => question.serviceid === serviceId && question.parent === questionId)
		}
	}
)

export const selectQuestionById = createSelector(
	(state, questionId) => state.serviceQuestionReducer,
	(_, questionId) => questionId,
	(questions, questionId) => {
		const result = questions.filter((question) => questionId === question.servicequestionid)
		return result[0]
	}
)
